// @flow
import * as React from 'react';
import type { TPlayersById } from '../../modules/types';
import {
	TradeInCell,
	TradeOutCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
	ButtonPrimary,
	ButtonSecondary
} from '../';
import { TransactionButtonsWrapper } from './TransactionButtonsWrapper';

type Props = {
	players_by_id: TPlayersById,
	trade: Object,
	rejectTrade: Function,
	acceptTrade: Function,
	handleTradeConfirmModal: Function,
}
export const TradeToUser = ({ trade, players_by_id, handleTradeConfirmModal }: Props) => {
	const { new_player_id, old_player_id, new_team_name, status } = trade;
	return (
		<TransactionPlayersWrapper>
			<TransactionPlayers>
				<p>
					{new_team_name} has offered:
				</p>
				{new_player_id.map(id => (<TradeInCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
			{status === 'accepted' ? null : (
				<TransactionButtonsWrapper>
					<ButtonPrimary inverted onClick={() => handleTradeConfirmModal(trade)}>
						ACCEPT OFFER
					</ButtonPrimary>
					<ButtonSecondary onClick={() => handleTradeConfirmModal(trade)}>
						CANCEL OFFER
					</ButtonSecondary>
				</TransactionButtonsWrapper>
			)}
			<TransactionPlayers>
				<p>
					To you, for:
				</p>
				{old_player_id.map(id => (<TradeOutCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
		</TransactionPlayersWrapper>
	);
};

export default TradeToUser;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeToUser.js